module.exports = __webpack_public_path__ + "index/img/login_weixin.3c6de945.svg";